import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "@emotion/styled";
import { useEffect } from "react";
import LendersTable from "./LendersTable/LendersTable";
import PreferencesSection from "./PreferencesSection/PreferencesSection";
import MainLayout from "src/layouts/MainLayout";
import Header from "./Header";
import LeftContent from "./LeftContent";
import { useDealerUserInfo } from "src/context/DealerUserInfoContext";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  box-sizing: border-box;
  text-align: center;
`;

const RightPaneContent = styled.div`
  padding-right: 80px;
`;

export default function () {
  const navigate = useNavigate();
  const location = useLocation();
  const [currentSection, setCurrentSection] = useState("overview");
  const { dealerUserInfo } = useDealerUserInfo();

  if (dealerUserInfo.role === "SALES_REPRESENTATIVE") {
    void navigate("/error", { state: { status: 403 }, replace: true });
    return;
  }

  useEffect(() => {
    const path = location.pathname.split("/").pop();
    setCurrentSection(path || "overview");
  }, [location]);

  return (
    <MainLayout
      page="DealerSettings"
      title="Dealer Settings"
      hasBorder={false}
      showHeading={false}
      header={<Header />}
      leftContent={<LeftContent currentSection={currentSection} />}
    >
      <RightPaneContent>
        {currentSection === "overview" && (
          <div>
            <h2>Overview Section</h2>
            <p>This section will contain dealer overview details.</p>
          </div>
        )}
        {currentSection === "preferences" && <PreferencesSection />}
        {currentSection === "lenders" && <LendersTable />}
      </RightPaneContent>
    </MainLayout>
  );
}
